import { Button } from '@tribeplatform/react-ui-kit/Button'
import { List } from '@tribeplatform/react-ui-kit/Layout'

import { fieldTypes, getFieldIcon, getFieldSetting } from './utils'

export const FieldTypePicker = ({ onChange }) => {
  return (
    <List spacing="sm">
      {fieldTypes.map(item => {
        const subtype = getFieldSetting(item, 'subtype')
        return (
          <List.Item key={subtype || item.type}>
            <Button
              variant="outline"
              size="lg"
              className="w-full py-3 text-lg flex"
              leadingIcon={getFieldIcon({ type: subtype || item.type })}
              onClick={() => onChange(item)}
            >
              <span>{item.name}</span>
              {item.description ? (
                <span className="mx-2 font-normal text-sm text-basicSurface-300">
                  {item.description}
                </span>
              ) : null}
            </Button>
          </List.Item>
        )
      })}
    </List>
  )
}
